import { Toggle } from 'rsuite';

import { ButtonPrimary } from '../../../../../../components/ButtonPrimary';
import { Callout } from '../../../../../../components/Callout';
import styles from '../SetupIpaPriceArchitecture.module.scss';
import { PriceArchitectureFormValues } from '../types';
import { PriceArchitecturePsychologicalPricing } from './PriceArchitecturePsychologicalPricing';

export type PriceArchitectureFormProps = {
  values: PriceArchitectureFormValues;
  isSaving: boolean;
  onEnabledChange: (enabled: boolean) => void;
  onApplyPsychologicalPricingChange: (applyPsychologicalPricing: boolean) => void;
  onCancel: () => void;
  onSave: () => void | Promise<void>;
};

export const PriceArchitectureForm = ({
  values,
  isSaving,
  onEnabledChange,
  onApplyPsychologicalPricingChange,
  onCancel,
  onSave,
}: PriceArchitectureFormProps) => (
  <form
    className={styles.page}
    onSubmit={event => {
      event.preventDefault();
      void onSave();
    }}
  >
    <section className={styles.configurationCard}>
      <header className={styles.header}>
        <h1>Arquitetura de preços</h1>
        <p>Habilitar e definir as configurações para arquitetura de preços</p>

        <div className={styles.toggleRow}>
          <Toggle size="sm" checked={values.enabled} onChange={checked => onEnabledChange(checked)} aria-labelledby="price-architecture-toggle-label" />
          <div className={styles.toggleText}>
            <h2 id="price-architecture-toggle-label">Usar Arquitetura de preços</h2>
            <p>Ative para precificar produtos de forma hierarquizada a partir de uma estrutura de arquitetura enviada via arquivo.</p>
          </div>
        </div>
      </header>

      {values.enabled && (
        <>
          <hr className={styles.divider} />
          <PriceArchitecturePsychologicalPricing value={values.applyPsychologicalPricing} onChange={onApplyPsychologicalPricingChange} />
        </>
      )}
    </section>

    <section className={styles.informationCard}>
      <Callout variant="warning" size="sm" className={styles.validityCallout}>
        <Callout.Description>
          As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia seguinte.
        </Callout.Description>
      </Callout>
    </section>

    <footer className={styles.actionsCard}>
      <ButtonPrimary type="button" theme="ghost" onClick={onCancel} disabled={isSaving}>
        Cancelar
      </ButtonPrimary>
      <ButtonPrimary type="submit" isLoading={isSaving}>
        Salvar
      </ButtonPrimary>
    </footer>
  </form>
);
